import { render, staticRenderFns } from "./LoginRoot.vue?vue&type=template&id=3732f7ae"
import script from "./LoginRoot.vue?vue&type=script&lang=ts"
export * from "./LoginRoot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports